import PageHeader from "@/components/feature/PageHeader";
import ContactForm from "./components/ContactForm";
import ContactInfo from "./components/ContactInfo";
import ContactMap from "./components/ContactMap";
import { useSEO } from "@/hooks/useSEO";

export default function Contact() {
  useSEO({
    title: "联系我们 - 白峰美羽",
    description: "联系白峰美羽品牌团队，了解合作、咨询与到访方式，欢迎留言与我们交流。",
    keywords: "白峰美羽,联系我们,品牌合作,客户咨询",
  });

  return (
    <>
      <PageHeader
        eyebrow="GET IN TOUCH"
        title="联系我们"
        description="无论是产品咨询、品牌合作，还是想了解更多白峰美羽的故事，我们都期待与您交流。"
        crumbs={[{ label: "首页", path: "/" }, { label: "联系我们" }]}
      />

      <section className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
          <div className="lg:col-span-2 flex flex-col gap-6">
            <ContactInfo />
            <ContactMap />
          </div>
        </div>
      </section>
    </>
  );
}